import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// redux
import { connect } from "react-redux";

let _colUidCounter = 0;
const genColUid = () => `col-${++_colUidCounter}`;

// inputIds dos componentes especiais que têm posição reservada
const BUTTON_INPUT_ID = 6;
const CAPTCHA_INPUT_ID = 11;

import { Button, Col, Input, Label, Row } from "reactstrap";

// service
import { createForm, updateForm, getAllForms } from "../../utils/services/rsvp";
import { getStatusRsvp } from "../../utils/services/statusRsvp";
import { getGroups } from "../../utils/services/group";

// Rows and Cols
import RowsAndCols from "./components/EditRowAndCols";

// Custom Components
import SelectInput from "./components/SelectInput";
import TextInput from "./components/TextInput";
import UploadInput from "./components/UploadInput";
import ThermInput from "./components/ThermInput";
import CheckboxInput from "./components/CheckboxInput";
import RadioInput from "./components/RadioInput";
import FormButton from "./components/FormButton";
import EmailInput from "./components/EmailInput";
import CellphoneInput from "./components/CellphoneInput";
import CPFInput from "./components/CPFInput";
import LabelInput from "./components/LabelInput";
import ErrorModal from "./components/ErrorModal";
import EntriesOptions from "./components/EntriesOptions";
import Captcha from "./components/Captcha";
import PasswordInput from "./components/PasswordInput";
import NameInput from "./components/NameInput";
import AgreeDisagreeInput from "./components/AgreeDisagreeInput";
import RatingInput from "./components/RatingInput";
import EmojiInput from "./components/EmojiInput";
import LinkButton from "./components/LinkButton";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

function CustomForm({
  toggle,
  createOrUpdate,
  eventId,
  selectedForm,
  action = "C",
  setStep = null,
  setSelectedForm = null,
  contractId,
  token,
}) {
  // Lista de grupos do evento — carregada uma vez e propagada como prop
  // pra cada input configurável (usada pela segregação por grupos).
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    if (!eventId || !token) return;
    (async () => {
      try {
        const res = await getGroups({
          jwt: token,
          eventId,
          offset: 1,
          limit: 0,
          search: "",
        });
        setGroups(res?.findOneGroupData?.data || []);
      } catch (err) {
        // silencioso — sem grupos, o Select fica vazio
      }
    })();
  }, [eventId, token]);

  // State do formulário
  const [formName, setFormName] = useState(
    selectedForm ? selectedForm.description : "",
  );
  const [isRegister, setIsRegister] = useState(
    selectedForm ? (selectedForm.cadastro ? "sim" : "nao") : "",
  );
  const [loadingButton, setLoadingButton] = useState(null);

  // Status RSVP — só relevante quando o form é de cadastro. Lista carregada
  // via getStatusRsvp filtrada pelo contrato do usuário logado.
  const [statusRsvpList, setStatusRsvpList] = useState([]);
  const [statusRsvpSelected, setStatusRsvpSelected] = useState(null);

  // Carrega a lista quando o form vira "cadastro" e o contractId existe.
  useEffect(() => {
    if (isRegister !== "sim") return;
    if (!contractId) return;
    if (statusRsvpList.length > 0) return;
    (async () => {
      const res = await getStatusRsvp({
        contractId,
        offset: 1,
        limit: 100,
        enabled: true,
      });
      if (res && Array.isArray(res.data)) {
        setStatusRsvpList(res.data);
      }
    })();
  }, [isRegister, contractId, statusRsvpList.length]);

  // Ao editar um form existente que já tem idStatusRsvp, pré-seleciona
  // quando a lista chega. O valor pode estar em duas fontes:
  //   1. Item de meta injetado no array do JSON: [{_meta: {idStatusRsvp}}, ...]
  //   2. Chave top-level do backend (se um dia adicionarem coluna dedicada).
  useEffect(() => {
    if (!selectedForm) return;
    if (statusRsvpList.length === 0) return;
    let initialId =
      selectedForm.idStatusRsvp ||
      selectedForm.id_status_rsvp ||
      selectedForm.statusRsvp?.id;
    if (!initialId) {
      try {
        const raw = selectedForm.json;
        const parsedJson = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (Array.isArray(parsedJson)) {
          const metaItem = parsedJson.find((item) => item && item._meta);
          initialId = metaItem?._meta?.idStatusRsvp || null;
        }
      } catch {
        /* se o parse falhar, o outro useEffect que carrega o form já loga */
      }
    }
    if (!initialId) return;
    const found = statusRsvpList.find((s) => s.id === initialId);
    if (found) {
      setStatusRsvpSelected({ label: found.description, value: found.id });
    }
  }, [selectedForm, statusRsvpList]);

  // Modal Edit Rows and Cols
  const [modalRowAndCol, setModalRowAndCol] = useState(false);
  const [rowsAndCols, setRowsAndCols] = useState([]);

  // Modal to add new component
  const [modal, setModal] = useState(false);

  // Linha de origem do drag de colunas (para controlar isDropDisabled)
  const [draggingFromRow, setDraggingFromRow] = useState(null);

  // Error Modal
  const [errorModal, setErrorModal] = useState(false);

  // Alerta de campos obrigatórios ausentes
  const [missingFieldsAlert, setMissingFieldsAlert] = useState(null);

  const [selectedRowAndCol, setSelectedRowAndCol] = useState({});

  // Current form
  const formRef = useRef([]);

  // Adiciona os atributos do componente no array
  const addAttributes = useCallback(({ rowId, colId, attributes }) => {
    const newRows = formRef.current.map((row) => {
      if (row.row === rowId) {
        return {
          ...row,
          cols: row.cols.map((col) => {
            if (col.col === colId) {
              return { ...col, attributes };
            }
            return col;
          }),
        };
      }
      return row;
    });

    formRef.current = newRows;
    setRowsAndCols(newRows);
  }, []);

  // Exclui o componente da coluna
  const deleteCustomInput = useCallback((rowId, colId) => {
    const newState = formRef.current.map((row, rIdx) => {
      if (rIdx === rowId) {
        return {
          ...row,
          cols: row.cols.map((col, cIdx) => {
            if (cIdx === colId) {
              return {
                ...col,
                input: undefined,
                inputId: undefined,
                attributes: undefined,
              };
            }
            return col;
          }),
        };
      }
      return row;
    });

    formRef.current = newState;
    setRowsAndCols(newState);
  }, []);

  // Lista os possiveis componentes a serem renderizados
  const components = useCallback(
    (rowId, colId, attributes, autoOpen = false) => [
      <TextInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <UploadInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <ThermInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <SelectInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <CheckboxInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <RadioInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <FormButton
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
      />,
      <EmailInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <CellphoneInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <CPFInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <LabelInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <Captcha
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
      />,
      <PasswordInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <NameInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <AgreeDisagreeInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <RatingInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <EmojiInput
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
      <LinkButton
        deleteComponent={deleteCustomInput}
        attributes={attributes}
        setAttributes={addAttributes}
        rowId={rowId}
        colId={colId}
        autoOpen={autoOpen}
        groups={isRegister === "sim" ? [] : groups}
      />,
    ],
    [deleteCustomInput, addAttributes, groups, isRegister],
  );

  // Atualiza o valor da posição da linha e coluna no array
  const updateRowsAndColsIndex = (newState, customComponent) => {
    const rows = newState.map((row, index) => {
      row.row = index;
      row.cols = row.cols.map((col, index) => {
        col.col = index;
        if (col.inputId !== undefined) {
          col.input = customComponent(row.row, col.col, col.attributes)[
            col.inputId
          ];
        }
        return col;
      });
      return row;
    });

    return rows;
  };

  // Garante a ordem: [...resto] → [captcha?] → [botão?]
  // Captcha fica antes do botão; se não houver botão, fica no final.
  const ensureSpecialInputsOrder = (rows, componentsFn) => {
    const buttonRowIndex = rows.findIndex((row) =>
      row.cols.some((col) => col.inputId === BUTTON_INPUT_ID),
    );
    const captchaRowIndex = rows.findIndex((row) =>
      row.cols.some((col) => col.inputId === CAPTCHA_INPUT_ID),
    );

    const hasButton = buttonRowIndex !== -1;
    const hasCaptcha = captchaRowIndex !== -1;

    if (!hasButton && !hasCaptcha) return rows;

    // Ambos na mesma linha: a linha vai para o final
    if (hasButton && hasCaptcha && buttonRowIndex === captchaRowIndex) {
      if (buttonRowIndex === rows.length - 1) return rows;
      const newRows = [...rows];
      const [row] = newRows.splice(buttonRowIndex, 1);
      newRows.push(row);
      return updateRowsAndColsIndex(newRows, componentsFn);
    }

    // Só botão: vai para o final
    if (hasButton && !hasCaptcha) {
      if (buttonRowIndex === rows.length - 1) return rows;
      const newRows = [...rows];
      const [row] = newRows.splice(buttonRowIndex, 1);
      newRows.push(row);
      return updateRowsAndColsIndex(newRows, componentsFn);
    }

    // Só captcha: vai para o final
    if (hasCaptcha && !hasButton) {
      if (captchaRowIndex === rows.length - 1) return rows;
      const newRows = [...rows];
      const [row] = newRows.splice(captchaRowIndex, 1);
      newRows.push(row);
      return updateRowsAndColsIndex(newRows, componentsFn);
    }

    // Ambos em linhas diferentes: captcha penúltimo, botão último
    const alreadyOrdered =
      captchaRowIndex === rows.length - 2 && buttonRowIndex === rows.length - 1;
    if (alreadyOrdered) return rows;

    // Remove do maior índice para o menor para não deslocar o outro
    const newRows = [...rows];
    const descIndices = [
      { id: "button", index: buttonRowIndex },
      { id: "captcha", index: captchaRowIndex },
    ].sort((a, b) => b.index - a.index);

    const removed = {};
    for (const { id, index } of descIndices) {
      const [row] = newRows.splice(index, 1);
      removed[id] = row;
    }

    newRows.push(removed.captcha);
    newRows.push(removed.button);

    return updateRowsAndColsIndex(newRows, componentsFn);
  };

  // Deleta uma coluna
  const deleteCol = (rowId, colId) => {
    const newState = [...formRef.current];
    newState[rowId].cols = newState[rowId].cols.filter(
      (item) => item.col !== colId,
    );
    if (newState[rowId].cols.length === 0) {
      newState.splice(rowId, 1);
    }

    const updated = updateRowsAndColsIndex(newState, components);
    formRef.current = updated;
    setRowsAndCols(updated);
  };

  // Adiciona uma linha e coluna(s) no array; reposiciona o botão ao final se existir
  const editRowAndCol = (cols) => {
    const newCol = {
      row: formRef.current.length,
      cols: [...new Array(+cols)].map((_e, i) => ({
        col: i,
        uid: genColUid(),
      })),
    };

    const appended = [...formRef.current, newCol];
    const updated = ensureSpecialInputsOrder(appended, components);
    formRef.current = updated;
    setRowsAndCols(updated);
  };

  // Marca a linha de origem ao iniciar drag de coluna
  const onDragStart = (start) => {
    if (start.type === "COL") {
      const rowIndex = parseInt(
        start.source.droppableId.replace("row-cols-", ""),
      );
      setDraggingFromRow(rowIndex);
    }
  };

  // Reordena linhas ou colunas via drag and drop
  const onDragEnd = (result) => {
    if (!result.destination) {
      setDraggingFromRow(null);
      return;
    }

    if (result.type === "ROW") {
      const newRows = [...formRef.current];
      const [moved] = newRows.splice(result.source.index, 1);
      newRows.splice(result.destination.index, 0, moved);
      const reordered = updateRowsAndColsIndex(newRows, components);
      const updated = ensureSpecialInputsOrder(reordered, components);
      formRef.current = updated;
      setDraggingFromRow(null);
      setRowsAndCols(updated);
      return;
    }

    if (result.type === "COL") {
      const sourceRowIndex = parseInt(
        result.source.droppableId.replace("row-cols-", ""),
      );
      const destRowIndex = parseInt(
        result.destination.droppableId.replace("row-cols-", ""),
      );

      const newRows = [...formRef.current];

      if (sourceRowIndex === destRowIndex) {
        const cols = [...newRows[sourceRowIndex].cols];
        const [moved] = cols.splice(result.source.index, 1);
        cols.splice(result.destination.index, 0, moved);
        newRows[sourceRowIndex] = { ...newRows[sourceRowIndex], cols };
      } else {
        const destCols = [...newRows[destRowIndex].cols];
        if (destCols.length >= 3) {
          setDraggingFromRow(null);
          return;
        }

        const sourceCols = [...newRows[sourceRowIndex].cols];
        const [moved] = sourceCols.splice(result.source.index, 1);
        destCols.splice(result.destination.index, 0, moved);

        newRows[sourceRowIndex] = {
          ...newRows[sourceRowIndex],
          cols: sourceCols,
        };
        newRows[destRowIndex] = { ...newRows[destRowIndex], cols: destCols };

        if (sourceCols.length === 0) {
          newRows.splice(sourceRowIndex, 1);
        }
      }

      const reordered = updateRowsAndColsIndex(newRows, components);
      const updated = ensureSpecialInputsOrder(reordered, components);
      formRef.current = updated;
      setDraggingFromRow(null);
      setRowsAndCols(updated);
    }
  };

  // Adiciona apenas uma coluna
  const addCol = (rowId, colId) => {
    const newState = [...formRef.current];

    if (newState[rowId].cols.length < 3) {
      newState[rowId].cols.push({ col: colId + 1, uid: genColUid() });
      const updated = updateRowsAndColsIndex(newState, components);
      setRowsAndCols(updated);
      formRef.current = updated;
    }
  };

  // Adiciona um componente customizado; reposiciona o botão ao final se necessário
  const addInput = (id) => {
    const newRowsAndCols = [...formRef.current];

    newRowsAndCols[selectedRowAndCol.row].cols[selectedRowAndCol.col].input =
      components(selectedRowAndCol.row, selectedRowAndCol.col, undefined, true)[
        id
      ];
    newRowsAndCols[selectedRowAndCol.row].cols[selectedRowAndCol.col].inputId =
      id;

    const updated = ensureSpecialInputsOrder(newRowsAndCols, components);
    formRef.current = updated;
    setRowsAndCols(updated);
  };

  // Verifica se a coluna está vazia ou sem atributos
  const hasEmptyFields = () =>
    rowsAndCols.some((row) =>
      row.cols.some((col) => !col.input || !col.attributes),
    );

  // Remove os componentes React do array antes de serializar para o banco
  const removeHtml = () => {
    return formRef.current.map((row) => ({
      ...row,
      cols: row.cols.map(({ input, uid, ...col }) => col),
    }));
  };

  const RECOMMENDED_FIELDS = [
    { uniqueField: "nome", label: "Nome" },
    { uniqueField: "email", label: "Email" },
  ];

  // Retorna os labels dos campos recomendados ausentes no formulário
  const getMissingRequiredFields = () => {
    const presentFields = formRef.current
      .flatMap((row) => row.cols)
      .filter((col) => col.attributes?.uniqueField)
      .map((col) => col.attributes.uniqueField);

    return RECOMMENDED_FIELDS.filter(
      (f) => !presentFields.includes(f.uniqueField),
    ).map((f) => f.label);
  };

  // Executa o salvamento efetivo
  const doSave = async (shouldExit) => {
    // O `idStatusRsvp` é injetado como item de meta dentro do array do JSON
    // (backend não tem coluna dedicada). Filtros existentes que iteram
    // `row.cols` já ignoram esse item — não quebra forms antigos.
    const rows = removeHtml();
    const idStatusRsvp =
      isRegister === "sim" && statusRsvpSelected?.value
        ? statusRsvpSelected.value
        : null;
    const rowsWithMeta = idStatusRsvp
      ? [{ _meta: { idStatusRsvp } }, ...rows]
      : rows;
    const json = JSON.stringify(rowsWithMeta);
    setLoadingButton(shouldExit ? "saveExit" : "save");

    try {
      let response;

      if (createOrUpdate === "create") {
        response = await createForm({
          data: {
            json,
            eventId,
            description: formName,
            cadastro: isRegister === "sim" ? true : false,
          },
        });

        const idCreated = response?.data?.data?.id ?? null;

        if (idCreated && !shouldExit) {
          const allForms = await getAllForms({
            eventId: eventId,
            offset: 1,
            limit: 99,
            search: "",
          });

          const searchId =
            allForms?.data?.forms?.find((form) => form.id === idCreated) ??
            null;

          if (searchId) {
            setSelectedForm(searchId);
            setStep("_c");
          }
        }
      } else {
        response = await updateForm({
          data: {
            json,
            id: selectedForm.id,
            description: formName,
            cadastro: isRegister === "sim" ? true : false,
          },
        });
      }

      if (response?.status >= 200 && response?.status < 300) {
        toast.success("Salvo com sucesso.");
        if (shouldExit) toggle();
      } else {
        toast.error("Erro ao salvar o formulário.");
      }
    } catch (error) {
      toast.error("Erro ao salvar o formulário.");
      console.log({ error });
    } finally {
      setLoadingButton(null);
    }
  };

  // Salva o formulário; se shouldExit=true, fecha o modal após salvar
  const saveForm = async (shouldExit) => {
    if (hasEmptyFields() || !formName || !isRegister) {
      setErrorModal(true);
      return;
    }

    if (isRegister === "sim") {
      const missing = getMissingRequiredFields();
      if (missing.length > 0) {
        setMissingFieldsAlert(missing);
        return;
      }
    }

    await doSave(shouldExit);
  };

  useEffect(() => {
    if (selectedForm) {
      const raw = selectedForm.json;
      let parsedJson;
      try {
        parsedJson = typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[CustomForm] Falha ao parsear form.json:", err, raw);
        return;
      }
      if (!Array.isArray(parsedJson)) {
        // eslint-disable-next-line no-console
        console.warn("[CustomForm] form.json não é array:", parsedJson);
        return;
      }
      const parsed = parsedJson
        .filter((row) => row && Array.isArray(row.cols))
        .map((row) => ({
          ...row,
          cols: row.cols.map((col) => {
            const input = components(row.row, col.col, col.attributes)[
              col.inputId
            ];
            if (col.inputId !== undefined && !input) {
              // eslint-disable-next-line no-console
              console.warn(
                "[CustomForm] input indefinido para inputId:",
                col.inputId,
                "col:",
                col,
              );
            }
            return { ...col, uid: genColUid(), input };
          }),
        }));

      const corrected = ensureSpecialInputsOrder(parsed, components);
      formRef.current = corrected;
      setRowsAndCols(corrected);
    } else {
      const buttonAttributes = {
        inputName: "Botao de envio",
        btnText: "Enviar",
        fontColor: "#fff",
        btnColor: "#007bff",
        btnPosition: "center",
      };
      const initialRow = {
        row: 0,
        cols: [
          {
            col: 0,
            uid: genColUid(),
            inputId: BUTTON_INPUT_ID,
            input: components(0, 0, buttonAttributes)[BUTTON_INPUT_ID],
            attributes: buttonAttributes,
          },
        ],
      };
      formRef.current = [initialRow];
      setRowsAndCols([initialRow]);
    }
  }, [selectedForm, components]);

  // Desabilita salvar quando só existe a linha padrão do botão (sem campos reais)
  const hasOnlyDefaultButtonRow = !rowsAndCols.some((row) =>
    row.cols.some(
      (col) =>
        col.inputId !== undefined &&
        col.inputId !== BUTTON_INPUT_ID &&
        col.inputId !== CAPTCHA_INPUT_ID,
    ),
  );

  return (
    <div className="custom-form-wrapper">
      <ErrorModal
        formName={formName}
        isRegister={isRegister}
        isOpen={errorModal}
        toggle={setErrorModal}
        rows={rowsAndCols}
      />
      {missingFieldsAlert && (
        <SweetAlert
          error
          title="Campos obrigatórios ausentes"
          confirmBtnText="Fechar"
          confirmBtnBsStyle="danger"
          onConfirm={() => setMissingFieldsAlert(null)}
        >
          O formulário precisa conter os seguintes campos:
          <ul style={{ textAlign: "left", marginTop: 8 }}>
            {missingFieldsAlert.map((field) => (
              <li key={field}>{field}</li>
            ))}
          </ul>
        </SweetAlert>
      )}
      <EntriesOptions
        isOpen={modal}
        toggle={setModal}
        addInput={addInput}
        data={rowsAndCols}
      />
      <RowsAndCols
        isOpen={modalRowAndCol}
        toggle={() => setModalRowAndCol((prev) => !prev)}
        setEditCols={editRowAndCol}
      />
      <Row>
        <Col md={6}>
          <Label className="fw-bold">Nome do formulário</Label>
          <Input
            type="text"
            placeholder="Nome do formulário"
            className="custom-form-mb"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
          />
        </Col>

        <Col md={6}>
          <div style={{ display: "flex", gap: 24 }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Label className="fw-bold">Formulário de Cadastro?</Label>
              <div style={{ marginTop: 10 }}>
                <Input
                  className="input-mg-rgt"
                  name="radio"
                  type="radio"
                  id={`cadastroSimRadio`}
                  checked={isRegister === "sim"}
                  onChange={(e) => setIsRegister("sim")}
                />
                <Label htmlFor={`cadastroSimRadio`} className="form-label">
                  Sim
                </Label>
              </div>

              <div>
                <Input
                  className="input-mg-rgt"
                  name="radio"
                  type="radio"
                  id={`cadastroNaoRadio`}
                  checked={isRegister === "nao"}
                  onChange={(e) => setIsRegister("nao")}
                />
                <Label htmlFor={`cadastroNaoRadio`} className="form-label">
                  Não
                </Label>
              </div>
            </div>

            {isRegister === "sim" && (
              <div style={{ flex: 1, minWidth: 200 }}>
                <Label className="fw-bold">Status RSVP</Label>
                <Select
                  value={statusRsvpSelected}
                  placeholder="Selecione"
                  onChange={(opt) => setStatusRsvpSelected(opt)}
                  options={statusRsvpList.map((s) => ({
                    label: s.description,
                    value: s.id,
                  }))}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  classNamePrefix="select2-selection"
                  isClearable
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
      <hr className="custom-form-divider" />
      <Row>
        <Col id="dragContainer" className="dragItems" sm="11">
          <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
            <Droppable
              droppableId="form-rows"
              type="ROW"
              isDropDisabled={false}
              isCombineEnabled={false}
              ignoreContainerClipping={false}
            >
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {rowsAndCols.map((e, index) => {
                    const isButtonRow = e.cols.some(
                      (col) => col.inputId === BUTTON_INPUT_ID,
                    );
                    return (
                      <Draggable
                        key={`row-drag-${index}`}
                        draggableId={`row-drag-${index}`}
                        index={index}
                        isDragDisabled={isButtonRow}
                      >
                        {(rowProvided) => (
                          <div
                            ref={rowProvided.innerRef}
                            {...rowProvided.draggableProps}
                          >
                            {!isButtonRow ? (
                              <div
                                className="drag-handle-bar"
                                {...rowProvided.dragHandleProps}
                                title="Arrastar linha"
                              >
                                <i className="mdi mdi-drag-horizontal-variant" />
                              </div>
                            ) : (
                              <span
                                {...rowProvided.dragHandleProps}
                                style={{ display: "none" }}
                              />
                            )}
                            <Droppable
                              droppableId={`row-cols-${index}`}
                              type="COL"
                              direction="horizontal"
                              isCombineEnabled={false}
                              ignoreContainerClipping={false}
                              isDropDisabled={Boolean(
                                draggingFromRow !== null &&
                                draggingFromRow !== index &&
                                e.cols.length >= 3,
                              )}
                            >
                              {(colProvided) => (
                                <div
                                  ref={colProvided.innerRef}
                                  {...colProvided.droppableProps}
                                  id={`row/${e.row}`}
                                  className="row custom-form-row"
                                >
                                  {e.cols.map((col, colIndex) => {
                                    const isButtonCol =
                                      col.inputId === BUTTON_INPUT_ID;
                                    return (
                                      <Draggable
                                        key={`col-drag-${index}-${colIndex}`}
                                        draggableId={`col-drag-${index}-${colIndex}`}
                                        index={colIndex}
                                        isDragDisabled={isButtonCol}
                                      >
                                        {(colDragProvided) => (
                                          <div
                                            ref={colDragProvided.innerRef}
                                            {...colDragProvided.draggableProps}
                                            className="col custom-form-col"
                                          >
                                            <div className="row-config-container">
                                              {isButtonCol ? (
                                                <span
                                                  {...colDragProvided.dragHandleProps}
                                                  style={{ display: "none" }}
                                                />
                                              ) : (
                                                <>
                                                  <i
                                                    className="mdi mdi-drag-vertical"
                                                    {...colDragProvided.dragHandleProps}
                                                    title="Arrastar coluna"
                                                  />
                                                  {e.cols.length ===
                                                    +col.col + 1 && (
                                                    <i
                                                      className="mdi mdi-plus"
                                                      title="Adicionar coluna"
                                                      onClick={() =>
                                                        addCol(e.row, col.col)
                                                      }
                                                    />
                                                  )}
                                                  <i
                                                    className="mdi mdi-close"
                                                    title="Remover coluna"
                                                    onClick={() =>
                                                      deleteCol(e.row, col.col)
                                                    }
                                                  />
                                                </>
                                              )}
                                            </div>
                                            <Row
                                              id={`col/${col.col}`}
                                              className="dragItem"
                                            >
                                              {React.isValidElement(
                                                col.input,
                                              ) ? (
                                                React.cloneElement(col.input, {
                                                  key: col.uid,
                                                })
                                              ) : (
                                                <button
                                                  className="select-input-btn"
                                                  onClick={() => {
                                                    setModal(true);
                                                    setSelectedRowAndCol({
                                                      row: e.row,
                                                      col: col.col,
                                                    });
                                                  }}
                                                >
                                                  <i className="mdi mdi-plus" />
                                                </button>
                                              )}
                                            </Row>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {colProvided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Row>
            <Button
              className="add-row-button"
              color="primary"
              onClick={() => setModalRowAndCol(true)}
            >
              Adicionar Linha
            </Button>
          </Row>
        </Col>
      </Row>
      <div className="save-btn-form-container">
        <ButtonSpinner
          isLoading={loadingButton === "save"}
          isDisabled={hasOnlyDefaultButtonRow}
          title={"Salvar"}
          onClick={() => saveForm(false)}
          action={action}
        />
        <ButtonSpinner
          isLoading={loadingButton === "saveExit"}
          isDisabled={hasOnlyDefaultButtonRow}
          title={"Salvar e Sair"}
          size={125}
          onClick={() => saveForm(true)}
          action={action}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  contractId: state?.global_user_data?.data?.theme?.[0]?.id,
  token: state?.global_user_data?.data?.token,
});

export default connect(mapStateToProps)(CustomForm);
